import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-948cd152"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fixed w-full z-50" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "flex min-h-screen flex-col pt-11 md:pt-14 pb-14 md:pb-0" }
const _hoisted_5 = { class: "w-full mt-auto pt-10" }
const _hoisted_6 = { class: "fixed w-full bottom-0 z-50" }
const _hoisted_7 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_layout_auth_mobile_header = _resolveComponent("layout-auth-mobile-header")!
  const _component_layout_auth_pc_header = _resolveComponent("layout-auth-pc-header")!
  const _component_base_back_icon = _resolveComponent("base-back-icon")!
  const _component_layouts_auth_width = _resolveComponent("layouts-auth-width")!
  const _component_layout_auth_contents_footer = _resolveComponent("layout-auth-contents-footer")!
  const _component_layout_auth_mobile_footer = _resolveComponent("layout-auth-mobile-footer")!
  const _component_layout_auth_sidebar = _resolveComponent("layout-auth-sidebar")!
  const _component_search_history = _resolveComponent("search-history")!

  return (_openBlock(), _createBlock(_component_search_history, null, {
    default: _withCtx(() => [
      _createVNode(_component_layout_auth_sidebar, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_Transition, {
              name: "fade",
              mode: "out-in"
            }, {
              default: _withCtx(() => [
                (_ctx.store.state.base.responsive.isMD)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createVNode(_component_layout_auth_mobile_header)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(_component_layout_auth_pc_header)
                    ]))
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_layouts_auth_width, null, {
                default: _withCtx(() => [
                  _createVNode(_component_base_back_icon)
                ]),
                _: 1
              }),
              _renderSlot(_ctx.$slots, "default", {}, undefined, true),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_layout_auth_contents_footer)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_Transition, {
              name: "fade",
              mode: "out-in"
            }, {
              default: _withCtx(() => [
                (_ctx.store.state.base.responsive.isMD)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createVNode(_component_layout_auth_mobile_footer)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}